import React, { useEffect, useState } from "react"
import { View, StyleSheet, ScrollView } from "react-native"
import { ActivityIndicator, Divider } from "react-native-paper"
import { baseColors, baseFontFamily } from "@Constants/baseStyles"
import { RFValue } from "react-native-responsive-fontsize"
import { PatientFollowUpService } from "@Services/PatientFollowUp.Service"
import { fullName } from "@Utils/utils"
import { defaultAgreementPayload, handlePrecheck } from "./Logic"
import { useRecoilValue } from "recoil"
import { userAtom } from "@Recoil/Atom/userAtom"
import { Spacer } from "@Components/Space"
import { NewProfList } from "./NewProfList"
import { AlreadyProfList } from "./AlreadyProfList"

export const ProfessionalList = () => {
    const user = useRecoilValue(userAtom)
    const [fetchingAllProfessionalHealth, setFetchingAllProfessionalHealth] = useState(false)
    const [updateList, setUpdateList] = useState(false)
    const [allProfessionalHealth, setAllProfessionalHealth] = useState([])
    const [payload, setPayload] = useState(defaultAgreementPayload)
    const [putPayload, setPutPayload] = useState([])

    const fetchAllProfessionalHealth = () => {
        setFetchingAllProfessionalHealth(true)
        PatientFollowUpService.getAllProfessionalHealth(user?.id)
            .then((response) => {
                const data = response?.data?.data
                console.log({ brute: data?.[0]?.professional })
                const optimized = Array.from(data ?? [], (item) => ({
                    ...item,
                    id: item?.professional?.id,
                    fullName: fullName(item?.professional?.firstName, item?.professional?.lastName),
                    isAcceptedByPatient: item?.isAcceptedByPatient,
                    isAcceptedByProfessional: item?.isAcceptedByProfessional,
                    isMedecinTraitant: item?.professional?.isMedecinTraitant
                }))

                handlePrecheck({ setPayload, professionals: optimized })
                setAllProfessionalHealth(optimized)
                setFetchingAllProfessionalHealth(false)
            })
            .catch(() => {
                setFetchingAllProfessionalHealth(false)
            })
    }

    useEffect(() => {
        const abortController = new AbortController()
        fetchAllProfessionalHealth()

        return () => {
            abortController.abort()
        }
    }, [updateList])

    const isLoading = fetchingAllProfessionalHealth

    return (
        <View>
            {isLoading ? (
                <ActivityIndicator color={baseColors.green.primary} style={{ padding: 30 }} size={"large"} />
            ) : (
                <ScrollView keyboardShouldPersistTaps={"handled"} nestedScrollEnabled>
                    <NewProfList
                        payload={payload}
                        setPayload={setPayload}
                        data={allProfessionalHealth}
                        loading={isLoading}
                        setUpdateList={setUpdateList}
                    />

                    <Spacer />

                    <Divider style={{ marginVertical: 20 }} />

                    <Spacer />

                    <AlreadyProfList
                        payload={putPayload}
                        setPayload={setPutPayload}
                        data={allProfessionalHealth}
                        loading={isLoading}
                        setUpdateList={setUpdateList}
                    />
                </ScrollView>
            )}
        </View>
    )
}

const styles = StyleSheet.create({
    divider: { height: 1, backgroundColor: baseColors.green.primary, width: "90%", alignSelf: "center" },
    titleStyle: {
        marginBottom: 10,
        fontSize: RFValue(14),
        fontFamily: baseFontFamily.OpenSansRegular,
        color: baseColors.green.primary
    },
    descriptionStyle: {
        fontSize: RFValue(16),
        lineHeight: 30,
        fontFamily: baseFontFamily.OpenSansSemiBold,
        color: baseColors.black
    },
    content: {
        flexDirection: "row",
        alignItems: "center",
        marginBottom: 10
    }
})
